import { IMethodData } from '@r1-frontend/ui-react/organisms/Payment/PaymentMethod';

import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetPaymentMethod = IAction<EPaymentActions.SET_PAYMENT_METHOD, IMethodData | null>

const setPaymentMethod = (method: IMethodData | null): TSetPaymentMethod => ({
    type: EPaymentActions.SET_PAYMENT_METHOD,
    payload: method,
});

export default setPaymentMethod;
